import { render, staticRenderFns } from "./abaRegistro.vue?vue&type=template&id=fd278192&"
import script from "./abaRegistro.vue?vue&type=script&lang=js&"
export * from "./abaRegistro.vue?vue&type=script&lang=js&"
import style0 from "./abaRegistro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports